import React from 'react';
import { Text, View, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { useDispatch } from 'react-redux';
import ModalContainerWithoutSafeArea from './ModalContainerWithoutSafeArea';
import colors from '../../theme/Colors';
import size from '../../theme/Fonts';
import images from '../../theme/Images';
import SlimOfferCoupon from '../prompts/SlimOfferCoupon';
import { AnalyticsManager } from '../../analytics';
import { removeOffer } from '../../actions/ActionTypes';
import { getScreenWidth } from '../../utils/LayoutUtility';

const PrePaidOfferModal = (props) => {
  const dispatch = useDispatch();
  const { navigation, route: { params: { offerModalData = {} } = {} } = {} } =
    props;
  const { coupon_codes, new_cart_value, old_cart_value, offers_prompts } =
    offerModalData;
  const dismissModal = () => {
    navigation.goBack();
  };
  const removePrePaidCoupon = () => {
    dispatch(
      removeOffer('remove_prepaid_only', () => {
        AnalyticsManager.logEvent('prepaid_ony_coupons_removed', {
          offer_ids: coupon_codes,
        });
      }, false),
    );
    dismissModal();
  };

  return (
    <ModalContainerWithoutSafeArea>
      <View style={styles.modalContainer}>
        <View style={styles.bottomModal}>
          <View style={styles.modalHeadingTextContainer}>
            <Text style={styles.modalHeadingText}>
              {`Remove ${coupon_codes.join(', ')}?`}
            </Text>
            <TouchableOpacity onPress={dismissModal} style={styles.crossButton}>
              <Image source={images.cross} style={styles.crossIcon} />
            </TouchableOpacity>
          </View>
          <Text
            style={styles.textStyle}
          >{`Current Bag value : ₹${old_cart_value}`}</Text>
          <Text style={styles.textStyle}>
            This will remove the following offers from the bag :
          </Text>
          <View style={{ marginVertical: 8 }}>
            {offers_prompts.map((offer, index) => (
              <SlimOfferCoupon
                key={index}
                coupon={offer.coupon_code}
                description={offer.message}
                couponCode={offer.coupon_code}
                navigation={navigation}
              />
            ))}
          </View>
          <Text
            style={styles.newCartValueText}
          >{`Your updated bag amount : ₹${new_cart_value}`}</Text>
          <TouchableOpacity
            style={styles.submitButton}
            onPress={removePrePaidCoupon}
          >
            <Text style={styles.submitButtonText}>{`Remove ${coupon_codes.join(
              ', ',
            )}`}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ModalContainerWithoutSafeArea>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    width: getScreenWidth(),
  },
  bottomModal: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.white,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    padding: 16,
    alignSelf: 'center',
  },
  modalHeadingTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  modalHeadingText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.foxyBlack,
  },
  crossButton: {
    padding: 8,
  },
  crossIcon: {
    height: 16,
    width: 16,
    tintColor: colors.foxyBlack,
  },
  textStyle: {
    fontFamily: 'Roboto-Regular',
    marginVertical: 10,
    color: colors.black,
    fontSize: size.h3,
    fontWeight: '450',
  },
  newCartValueText: {
    fontFamily: 'Roboto-Regular',
    marginBottom: 12,
    color: colors.black,
    fontSize: size.h3,
    fontWeight: '450',
  },
  submitButton: {
    backgroundColor: colors.codGray,
    paddingVertical: 12,
    borderRadius: 4,
    alignItems: 'center',
    marginTop: 10,
  },
  submitButtonText: {
    fontFamily: 'Roboto-Regular',
    color: colors.white,
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default PrePaidOfferModal;
